export const sessionTypes = [
  { value: 'presentation', label: 'Presentation' },
  { value: 'panel', label: 'Panel Discussion' },
  { value: 'workshop', label: 'Workshop' },
];
